export enum ReplacementType {
  DriveUnit = "DriveUnit",
  DUMechanics = "DUMechanics",
  PCB = "PCB",
}

export const getReplacementSerialNumberValidationError = (
  serialNumber: string,
  replacementType: ReplacementType | null
): string | null => {
  if (replacementType === ReplacementType.PCB && /pcb0/i.test(serialNumber.trim())) {
    return "PCB0 uses the number zero. Replace 0 with the letter O: PCBO.";
  }

  return null;
};

export const isDriveUnitReplacement = (replacementType: ReplacementType): boolean =>
  replacementType === ReplacementType.DriveUnit || replacementType === ReplacementType.DUMechanics;

export const getReplacementTypeLabel = (replacementType: ReplacementType): string => {
  switch (replacementType) {
    case ReplacementType.DriveUnit:
      return "Drive Unit + PCB";
    case ReplacementType.DUMechanics:
      return "Drive Unit mechanics";
    case ReplacementType.PCB:
      return "PCB (electrical board)";
  }
};

export enum ReplacementState {
  Form = "form",
  Loading = "loading",
  Success = "success",
  Error = "error",
}

export interface IReplacementData {
  trackerId: number;
  trackerName: string;
  replacementType: ReplacementType;
  serialNumber: string;
  reason: string;
}

export enum DriveUnitReplacementReasons {
  InternalWaterDamage = "Internal water damage",
  NaturalEventDamage = "Damage caused by a natural event",
  MotorSoundGearNotMoving = "Motor produces sound but the gear does not move",
  Other = "Other",
}

export enum PcbReplacementReasons {
  ElectricalDamage = "Electrical damage",
  LedNotTurningOn = "LED not turning on",
  PcbNotCharging = "PCB not charging",
  Other = "Other",
}

export interface IInitiateReplacementResponse {
  processId: string;
}
